


































import { Component, Prop, Vue } from "vue-property-decorator";
import ListSkriningMpp from "@/components/mpp/ListSkriningMpp.vue";

@Component({
  components: { ListSkriningMpp }
})
export default class SkriningMppModal extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Array, default: () => [] }) items!: any[];
  @Prop({ type: Boolean, default: false }) isReadonly!: boolean;

  get dialog(): boolean {
    return this.value;
  }
  set dialog(val: boolean) {
    this.$emit("input", val);
  }
}
